const isArrayValuesUnique = (array: unknown) => {
  return Array.isArray(array) && new Set(array).size === array.length;
};

export default isArrayValuesUnique;
